import { LatLngMetadata, LatLngSlackChannels } from './useLatLngMetadata.types';

/**
 * A rollout helper to handle new API response format with the
 * 'lat_lng_private_metadata_min_version' runtime config. After the app version
 * matching that config is deployed, we can probably replace this util with just
 * `latLngMetadata?.private || {}`.
 */
export const getSlackChannelsFromMetadata = (
  latLngMetadata?: LatLngMetadata,
): Partial<LatLngSlackChannels> => {
  // 'lat_lng_private_metadata_min_version' runtime config is not applied - legacy behavior to remove
  if (latLngMetadata && !('private' in latLngMetadata)) {
    return {
      wildfireChannel:
        'wildfireChannel' in latLngMetadata
          ? latLngMetadata.wildfireChannel
          : undefined,
      wildfireChannelId:
        'wildfireChannelId' in latLngMetadata
          ? latLngMetadata.wildfireChannelId
          : undefined,
      floodingChannel:
        'floodingChannel' in latLngMetadata
          ? latLngMetadata.floodingChannel
          : undefined,
      floodingChannelId:
        'floodingChannelId' in latLngMetadata
          ? latLngMetadata.floodingChannelId
          : undefined,
    };
  }

  return latLngMetadata && 'private' in latLngMetadata
    ? latLngMetadata.private || {}
    : {};
};
